// JsFromRoutes CacheKey 07a2908a98e8d5f69be3ac4adf218c49
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/inboxes'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inboxes/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/inboxes/:id'),
}
